import "./related-articles-wrapper";

class RelatedArticles extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper, Pagination }) => {
      const swiperParams = {
        modules: [Pagination],
        slidesPerView: "auto",
        navigation: {
          nextEl: this.querySelector("[data-related-articles-navigation-next]"),
          prevEl: this.querySelector(
            "[data-related-articles-navigation-previous]",
          ),
        },
        pagination: {
          clickable: true,
          enabled: true,
          el: ".swiper-pagination",
        },
        breakpoints: {
          960: {
            pagination: {
              enabled: false,
            },
          },
        },
        on: {
          lock: () => {
            this.classList.add("related-articles__carousel-wrapper--locked");
          },
          unlock: () => {
            this.classList.remove("related-articles__carousel-wrapper--locked");
          },
        },
      };

      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}
}

if (!customElements.get("related-articles")) {
  customElements.define("related-articles", RelatedArticles);
}